<template>
	<div class="warpper">
		<div class="dome">
			<router-link to="/Index">首页</router-link>
			<router-link to="/Details">产品概况</router-link>
			<router-link to="/Video">视频监控</router-link>
			<router-link to="/Policy">政策措施</router-link>
			<router-link to="/Policy1">政策措施1</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Home',
		components: {
		},
		data() {
			return {
				
			};
		},
		methods: {

		},
		mounted() {

		}
	}
</script>
<style scoped>
	.dome{
		padding: 50px;
	}
	.dome a{
		display: block;
		margin-bottom: 30px;
	}

	
</style>
